import { Box, IconButton } from "@mui/material";
import TitleBar from "../../titleBar/TitleBar";
import { ArrowBack, HolidayVillage } from "@mui/icons-material";
import { Link } from "react-router-dom";
import BoilerApartMenu from "../boilerApartMenu/BoilerApartMenu";

export const BoilerApartCard = ({ apartList, apartmentId, userName }) => {
  const item = apartList.find(item => item.id == apartmentId);
  if (!item) return null;
  return (
    <Box key={item.id}>
      <TitleBar
        arrow={
          <IconButton component={Link} to="/apartments">
            <ArrowBack />
          </IconButton>
        }
        icon={
          <HolidayVillage
            color="primary"
            fontSize="large"
            sx={{ m: "0 10px 0" }}
          />
        }
        title={`Котёл ${item.boilerName}`}
      />
      <BoilerApartMenu boilerAparts={apartList} userName={userName} />
    </Box>
  );
};